<style>
/* Mobile <576px */
@media (max-width: 576px) {

  .Login_page .container {
    justify-content: center !important;
    flex-direction: column;
    padding: 20px;
  }

  .login-box {
    width: 100% !important;
    max-width: 100% !important;
    margin: 20px auto;
    padding: 20px !important;
    height: auto;
    box-sizing: border-box;
  }

  .login_textbox h1 {
    font-size: 1.5rem !important;
  }

  .login_textbox h4 {
    font-size: 1rem !important;
  }

  h1, h5, p {
    text-align: center;
  }

  .profile-container {
    width: 120px;
    height: 120px;
    margin: 0 auto;
  }

  .footer-logo {
    max-width: 150px;
  }
  .logo img {
    width: 200px !important;   /* adjust as needed */
    max-width: 100%; /* prevents stretching */
  }
  .login_textbox {
    width: 200px !important;   /* adjust as needed */
    max-width: 100%; /* prevents stretching */
  }
  .bottom-links {
    padding: 10px 5px;
  }
}

/* Tablet: 576px to 800px */
@media (max-width: 800px) {

  .Login_page .container {
    justify-content: center !important;
    padding: 20px;
  }

  .login-box {
    width: 90% !important;
    margin: 20px auto;
  }

  .login_textbox h1 {
    font-size: 1.7rem;
  }
}

</style>
<template>
    <!-- <div> -->
      <section class="Login_page">
        <div class="container d-flex justify-content-md-center justify-content-xl-end align-items-center min-vh-100">
          <div class="login-box p-md-5  p-lg-3 p-3">
            <div class="logo pt-lg-4">
              <a :href="landingHomepage">
                <img src="@/assets/Images/Logo/kims-logo.png" alt="KIMS Health Logo" />
              </a>
            </div>
  
            <div class="login_textbox p-lg-4 py-1 px-2">
              <h4 class="pt-2">Welcome to</h4>
              <h1 class="my-1">KIMSHEALTH</h1>
              <h4>VISA Medical Online Appointments</h4>
            </div>
  
            <div class="ps-lg-5 ps-2">
              <h1 class="mt-lg-2 pt-lg-2 pt-2">Track</h1>
              <h5 class="mt-3">Visa Medical Appointment</h5>
              <p class="mt-3">Please enter your Mobile number/Booking number</p>
              <input
                type="text"
                v-model="phone"
                :class="['mt-3 form-control border-bottom custom-input', { 'is-invalid': errors.phoneError }]"
                placeholder="Phone/Booking number*"
              />
              <small v-if="errors.phoneError" class="text-danger">{{ errors.phoneError }}</small>
  
              <button
                @click="TrackValidation"
                class="btn track-btn mt-5 py-3"
                :disabled="loading"
                style="text-decoration: none;"
              >
                <span v-if="!loading">Confirm</span>
                <span v-else>
                  <i class="fa fa-spinner fa-spin"></i> Processing...
                </span>
              </button>
            </div>
  
            <div class="bottom-links mt-lg-4 mt-2">
              <a :href="landingHomepage">Home</a> |
              <a :href="privacy_policy" class="ms-1">Privacy Policy</a> |
              <!-- <a href="https://visamedical.kimshealth.org/refund-policy" class="ms-1">Refund Policy</a> | -->
              <a :href="terms_and_conditions" class="ms-1">Terms & Conditions</a>
            </div>
          </div>
        </div>
      </section>

      <!-- OTP Modal Component -->
      <TrackingOTP v-if="showTrackingOtpModal" :otpData="otpData" :phonenumber="phone" :showTrackingOtpModal="showTrackingOtpModal" />

    <!-- </div> -->
  </template>
  
  <script>
  import TrackingOTP from '@/components/Track/models/TrackingOtp.vue';
  import 'bootstrap/dist/js/bootstrap.bundle.min.js';
  import { SendOtp, TokenRefresh } from '@/api/Post/track.js';
  import { LogoutPage } from '@/api/Post/action.js';
  import { useUserStore } from '@/store/user';
  import { useAgentStore } from '@/store/agent';
  export default {
  components: {
    TrackingOTP,
  },
  mounted() {
    const userStore = useUserStore();
    const token = userStore.authToken || localStorage.getItem('authToken');
    if (token) {
      userStore.setToken(token); 
      this.loadRefreshToken();
    } 
    // else {
    //   console.log('No token found, skipping refresh');
    // }
  },
  data() {
    return {
      phone: '',
      errors: {},
      landingHomepage: '/',
      TrackViewDetails: '/track/track-view-details',
      showTrackingOtpModal: false,
      loading: false,
      otpData: {}, 
      privacy_policy : '/privacy-policy',
      terms_and_conditions : '/terms-conditions',
    };
  },
  methods: {
    async TrackValidation() {
        this.errors = {};
        const phoneTrimmed = this.phone.trim();

        // if (!phoneTrimmed) {
        //     this.errors.phoneError = 'Please Enter Mobile / Booking Number.';
        // } 
        if (!phoneTrimmed) {
          this.errors.phoneError = 'Please Enter Mobile / Booking Number.';
        } else if (!/^\d{10}$/.test(phoneTrimmed) && phoneTrimmed.length < 5) {
          this.errors.phoneError = 'Enter valid Mobile or Booking number.';
        }
        // else if (!/^\d{10}$/.test(phoneTrimmed)) {
        //     this.errors.phoneError = 'Phone number must be exactly 10 digits.';
        // }

        if (!this.errors.phoneError) {
            this.loading = true;

            try {

            const sendOTP = await SendOtp(phoneTrimmed);

            if (sendOTP.data.success === true) {
                this.otpData = sendOTP.data; 
                //console.log('OTP Data:', this.otpData);
                this.showTrackingOtpModal = true; 
            } else {
                this.errors.phoneError = sendOTP.data.message || 'Error sending OTP.';
            }
            } catch (error) {
              this.errors.phoneError = 'We\'re sorry, but we could not find any matching records.';
              // this.errors.phoneError = error?.message || 'Something went wrong.';
            } finally {
            this.loading = false;
            }
        }
    },
    loadRefreshToken(){
     LogoutPage().then((response) => {
              if (response.data.success === false) {
                //console.log('Error refreshing token:');
              } else {
                ///console.log('Token refreshed successfully:');
                const userStore = useUserStore();
                userStore.logout();
                const agentStore = useAgentStore();
                agentStore.loadAgent();
              }
            })
            .catch((error) => {
              ///console.error("Axios Error:", error);

              if (error.response && error.response.data) {
                //console.log('Catch error1:');
              } else if (error.message) {
                //console.log('Catch error2:');
              } else {
                //console.log('Catch error3:');
              }
            });
    },
  }
};
</script>
  